import React, { useState } from "react";
import "./modalAddBank.css";

import { createPortal } from "react-dom";

const ModalAddBank = ({
  isShowModal,
  onCloseModal,
  onSubmitData,
  bankObject,
}) => {
  const [bankData, setBankData] = useState(bankObject);

  const closeModal = () => {
    setBankData({
      bank_id: "",
      bank_name: "",
    });
    onCloseModal();
  };

  return createPortal(
    isShowModal && (
      <div className="modal-bank-container">
        <div className="modal-bank-content">
          <header className="modal-bank-header">
            <h2 className="modal-bank-header-title">Tambah Bank</h2>
            <button className="modal-header-close-button" onClick={closeModal}>
              &times;
            </button>
          </header>
          <main className="modal-bank-main">
            <div className="form-group-bank">
              <div className="input-title-label-container">
                <span className="input-title-label">Nama Bank</span>
              </div>
              <div className="input-patient-field-container">
                <input
                  type="text"
                  value={bankData.bank_name ? bankData.bank_name : ""}
                  onChange={(e) =>
                    setBankData({
                      ...bankData,
                      bank_name: e.target.value,
                    })
                  }
                  placeholder="Masukkan nama bank"
                />
              </div>
            </div>
          </main>
          <footer className="modal-bank-footer">
            <button className="modal-close-button" onClick={closeModal}>
              Batal
            </button>
            <button
              className="modal-submit-button"
              onClick={() => {
                const isEditData = bankData.bank_id !== "";
                onSubmitData(bankData, isEditData);
                setBankData({
                  setBankData: "",
                  bank_name: "",
                });
              }}
            >
              Submit
            </button>
          </footer>
        </div>
      </div>
    ),
    document.getElementById("modal")
  );
};

export default ModalAddBank;
